import { Reducer } from 'redux'
import { UserActionTypes, UserState } from './types'
import { removeLocalStorageRefreshToken, removeLocalStorageUserToken } from '../../utils/localStorage'

export const initialState: UserState = {
  userData: null,
  isLoggedIn: false,
  loading: false,
  error: ''
}

const reducer: Reducer<UserState> = (state = initialState, action) => {
  switch (action.type) {
    case UserActionTypes.USER_LOGIN: {
      return { ...state, loading: false, error: '', isLoggedIn: true, userData: action.payload }
    }
    case UserActionTypes.USER_LOGOUT: {
      removeLocalStorageUserToken()
      removeLocalStorageRefreshToken()

      return { ...state, loading: false, error: '', isLoggedIn: false, userData: null }
    }

    case UserActionTypes.SET_USER_LOADING: {
      return { ...state, loading: true }
    }

    case UserActionTypes.SET_USER_ERROR: {
      return { ...state, loading: false, isLoggedIn: false, userData: null, error: action.payload }
    }

    default: {
      return state
    }
  }
}

export { reducer as userReducer }
